export let INPUT_FIELD_TYPES = /*#__PURE__*/function (INPUT_FIELD_TYPES) {
  INPUT_FIELD_TYPES["CONTACTS_FIRST_NAME"] = "CONTACTS_FIRST_NAME";
  INPUT_FIELD_TYPES["CONTACTS_LAST_NAME"] = "CONTACTS_LAST_NAME";
  INPUT_FIELD_TYPES["CONTACTS_EMAIL"] = "CONTACTS_EMAIL";
  INPUT_FIELD_TYPES["CONTACTS_PHONE"] = "CONTACTS_PHONE";
  INPUT_FIELD_TYPES["CONTACTS_ADDRESS"] = "CONTACTS_ADDRESS";
  INPUT_FIELD_TYPES["CONTACTS_SUBSCRIBE"] = "CONTACTS_SUBSCRIBE";
  INPUT_FIELD_TYPES["TEXT_INPUT"] = "TEXT_INPUT";
  INPUT_FIELD_TYPES["NUMBER_INPUT"] = "NUMBER_INPUT";
  INPUT_FIELD_TYPES["URL_INPUT"] = "URL_INPUT";
  INPUT_FIELD_TYPES["TEXT_AREA"] = "TEXT_AREA";
  INPUT_FIELD_TYPES["DATE_PICKER"] = "DATE_PICKER";
  INPUT_FIELD_TYPES["RADIO_GROUP"] = "RADIO_GROUP";
  INPUT_FIELD_TYPES["CHECKBOX_GROUP"] = "CHECKBOX_GROUP";
  INPUT_FIELD_TYPES["QUIZ_MULTI_CHOICE"] = "QUIZ_MULTI_CHOICE";
  INPUT_FIELD_TYPES["QUIZ_SINGLE_CHOICE"] = "QUIZ_SINGLE_CHOICE";
  INPUT_FIELD_TYPES["QUIZ_SHORT_TEXT"] = "QUIZ_SHORT_TEXT";
  INPUT_FIELD_TYPES["QUIZ_LONG_TEXT"] = "QUIZ_LONG_TEXT";
  INPUT_FIELD_TYPES["QUIZ_NUMBER"] = "QUIZ_NUMBER";
  INPUT_FIELD_TYPES["QUIZ_FILE_UPLOAD"] = "QUIZ_FILE_UPLOAD";
  INPUT_FIELD_TYPES["FILE_UPLOAD"] = "FILE_UPLOAD";
  INPUT_FIELD_TYPES["CHECKBOX"] = "CHECKBOX";
  INPUT_FIELD_TYPES["DROPDOWN"] = "DROPDOWN";
  INPUT_FIELD_TYPES["NESTED_FORM"] = "NESTED_FORM";
  INPUT_FIELD_TYPES["MULTILINE_ADDRESS"] = "MULTILINE_ADDRESS";
  INPUT_FIELD_TYPES["MLA_COUNTRY"] = "MLA_COUNTRY";
  INPUT_FIELD_TYPES["MLA_CITY"] = "MLA_CITY";
  INPUT_FIELD_TYPES["MLA_ADDRESS_LINE"] = "MLA_ADDRESS_LINE";
  INPUT_FIELD_TYPES["MLA_ADDRESS_LINE_2"] = "MLA_ADDRESS_LINE_2";
  INPUT_FIELD_TYPES["MLA_POSTAL_CODE"] = "MLA_POSTAL_CODE";
  INPUT_FIELD_TYPES["MLA_SUBDIVISION"] = "MLA_SUBDIVISION";
  INPUT_FIELD_TYPES["MLA_STREET_NAME"] = "MLA_STREET_NAME";
  INPUT_FIELD_TYPES["MLA_STREET_NUMBER"] = "MLA_STREET_NUMBER";
  INPUT_FIELD_TYPES["MLA_APARTMENT"] = "MLA_APARTMENT";
  INPUT_FIELD_TYPES["FULL_NAME_FIRST_NAME"] = "FULL_NAME_FIRST_NAME";
  INPUT_FIELD_TYPES["FULL_NAME_LAST_NAME"] = "FULL_NAME_LAST_NAME";
  INPUT_FIELD_TYPES["FULL_NAME"] = "FULL_NAME";
  INPUT_FIELD_TYPES["VAT_ID"] = "VAT_ID";
  INPUT_FIELD_TYPES["DEXT_TEXT_INPUT"] = "DEXT_TEXT_INPUT";
  INPUT_FIELD_TYPES["DEXT_TEXT_AREA"] = "DEXT_TEXT_AREA";
  INPUT_FIELD_TYPES["DEXT_DROPDOWN"] = "DEXT_DROPDOWN";
  INPUT_FIELD_TYPES["DEXT_URL_INPUT"] = "DEXT_URL_INPUT";
  INPUT_FIELD_TYPES["DEXT_RADIO_GROUP"] = "DEXT_RADIO_GROUP";
  INPUT_FIELD_TYPES["DEXT_NUMBER_INPUT"] = "DEXT_NUMBER_INPUT";
  INPUT_FIELD_TYPES["DEXT_CHECKBOX"] = "DEXT_CHECKBOX";
  INPUT_FIELD_TYPES["DEXT_CHECKBOX_GROUP"] = "DEXT_CHECKBOX_GROUP";
  INPUT_FIELD_TYPES["DEXT_EMAIL"] = "DEXT_EMAIL";
  INPUT_FIELD_TYPES["DEXT_PHONE"] = "DEXT_PHONE";
  INPUT_FIELD_TYPES["ECOM_ADDRESS"] = "ECOM_ADDRESS";
  INPUT_FIELD_TYPES["ECOM_FULL_NAME"] = "ECOM_FULL_NAME";
  INPUT_FIELD_TYPES["ECOM_PHONE"] = "ECOM_PHONE";
  INPUT_FIELD_TYPES["ECOM_COMPANY_NAME"] = "ECOM_COMPANY_NAME";
  INPUT_FIELD_TYPES["ECOM_EMAIL"] = "ECOM_EMAIL";
  return INPUT_FIELD_TYPES;
}({});
export let READONLY_FIELD_TYPES = /*#__PURE__*/function (READONLY_FIELD_TYPES) {
  READONLY_FIELD_TYPES["HEADER"] = "HEADER";
  READONLY_FIELD_TYPES["RICH_TEXT"] = "RICH_TEXT";
  READONLY_FIELD_TYPES["SUBMIT_BUTTON"] = "SUBMIT_BUTTON";
  return READONLY_FIELD_TYPES;
}({});
const TEXT_INPUT_FIELD_TYPES = {
  [INPUT_FIELD_TYPES.CONTACTS_FIRST_NAME]: INPUT_FIELD_TYPES.CONTACTS_FIRST_NAME,
  [INPUT_FIELD_TYPES.CONTACTS_LAST_NAME]: INPUT_FIELD_TYPES.CONTACTS_LAST_NAME,
  [INPUT_FIELD_TYPES.CONTACTS_EMAIL]: INPUT_FIELD_TYPES.CONTACTS_EMAIL,
  [INPUT_FIELD_TYPES.CONTACTS_PHONE]: INPUT_FIELD_TYPES.CONTACTS_PHONE,
  [INPUT_FIELD_TYPES.CONTACTS_ADDRESS]: INPUT_FIELD_TYPES.CONTACTS_ADDRESS,
  [INPUT_FIELD_TYPES.TEXT_INPUT]: INPUT_FIELD_TYPES.TEXT_INPUT,
  [INPUT_FIELD_TYPES.NUMBER_INPUT]: INPUT_FIELD_TYPES.NUMBER_INPUT,
  [INPUT_FIELD_TYPES.URL_INPUT]: INPUT_FIELD_TYPES.URL_INPUT,
  [INPUT_FIELD_TYPES.QUIZ_SHORT_TEXT]: INPUT_FIELD_TYPES.QUIZ_SHORT_TEXT,
  [INPUT_FIELD_TYPES.QUIZ_NUMBER]: INPUT_FIELD_TYPES.QUIZ_NUMBER
};
export const FIELD_TYPES = {
  ...INPUT_FIELD_TYPES,
  ...READONLY_FIELD_TYPES
};
// eslint-disable-next-line @typescript-eslint/no-redeclare

export let DEXT_FIELD_TYPES = /*#__PURE__*/function (DEXT_FIELD_TYPES) {
  DEXT_FIELD_TYPES["DEXT_CHECKBOX"] = "DEXT_CHECKBOX";
  DEXT_FIELD_TYPES["DEXT_CHECKBOX_GROUP"] = "DEXT_CHECKBOX_GROUP";
  DEXT_FIELD_TYPES["DEXT_DROPDOWN"] = "DEXT_DROPDOWN";
  DEXT_FIELD_TYPES["DEXT_NUMBER_INPUT"] = "DEXT_NUMBER_INPUT";
  DEXT_FIELD_TYPES["DEXT_RADIO_GROUP"] = "DEXT_RADIO_GROUP";
  DEXT_FIELD_TYPES["DEXT_TEXT_AREA"] = "DEXT_TEXT_AREA";
  DEXT_FIELD_TYPES["DEXT_TEXT_INPUT"] = "DEXT_TEXT_INPUT";
  DEXT_FIELD_TYPES["DEXT_URL_INPUT"] = "DEXT_URL_INPUT";
  DEXT_FIELD_TYPES["DEXT_EMAIL"] = "DEXT_EMAIL";
  DEXT_FIELD_TYPES["DEXT_PHONE"] = "DEXT_PHONE";
  return DEXT_FIELD_TYPES;
}({});
//# sourceMappingURL=field-types.js.map